import React from "react";
import clsx from "clsx";
import EmailLink from "../../laco-common/components/EmailLink";

type EmailLinkWebProps = {
	email: string;
	className?: string;
	orangeLink?: boolean;
};

export const EmailLinkWeb: React.FC<EmailLinkWebProps> = (props: EmailLinkWebProps) => {
	if (!props.email) return null;
	return (
		<span
			className={clsx(
				"inner-link d-inline-flex align-items-center",
				props.className,
				props.orangeLink && "orange-link",
				!props.orangeLink && "gray-link"
			)}
		>
			<i className="im im-mail" style={{ fontSize: "8px", marginRight: "6px", marginTop: "2px" }}></i>
			<EmailLink email={props.email} />
		</span>
	);
};
